import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';
import { FinanceFilters } from '../types';
import { VOApiFilterType } from 'modules/vendorOpportunity/filters';
import { useFilterOptions } from 'modules/vendorOpportunity/list/api';

export const FinanceSalesRep = () => {
  const { control } = useFormContext<FinanceFilters>();

  const { options, loading } = useFilterOptions(VOApiFilterType.SALES_REP);

  const mappedOptions = options.map(({ label, value }) => ({ label, value }));

  return (
    <AutocompleteField
      multiple
      size="small"
      name="SALES_REP"
      loading={loading}
      control={control}
      disableCloseOnSelect
      options={mappedOptions}
      disabled={!mappedOptions.length}
      textFieldProps={{
        size: 'small',
        variant: 'outlined',
        label: 'Sales Rep',
      }}
    />
  );
};
